
    /**
    * 发送短信
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    /**
 * OfficalSmsCheckCodeParam :OfficalSmsCheckCodeParam
 */
export class IReqApiEmployeeSmsSend28735 {
  /**
   * 手机号
   */
  mobile: string;
  /**
   * 阿里验证码2.0验证参数
   */
  captchaVerifyParam?: string;
  /**
   * 阿里验证码2.0场景ID
   */
  sceneId?: string;
  /**
   * 兼容@ywfe/authmodules返回结构
   */
  sliderParam?: {
    captchaVerifyParam?: string;
    sceneId?: string;
  };
  /**
   * 业务场景
   */
  scene?: string;
}
    /**
 * YResult<Void> :YResult
 */
export class IResApiEmployeeSmsSend28735 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * Void
   */
  data?: {};
  exceptionMsg?: {};
}
    const http: Serve<IReqApiEmployeeSmsSend28735, IResApiEmployeeSmsSend28735> = (data?) =>  request({
      method: 'POST',
      url: '/api/employee/sms/send',
      data:data,
      headers:{'Content-Type': 'application/json;charset=UTF-8'}
    }) 
    export default http
